const DB_NAME = import.meta.env.VITE_OUTPUT_DIR;
const DB_VERSION = 2;
let DB;

export default {
    async getDb() {
        return new Promise((resolve, reject) => {
            if(DB) { return resolve(DB); }
            let request = window.indexedDB.open(DB_NAME, DB_VERSION);
            request.onupgradeneeded = e => {
                let db = e.target.result;
                if (!Object.values(db.objectStoreNames).find(object => object == 'config')) {
                    db.createObjectStore("config", { autoIncrement: false, keyPath:'isu' });
                }
                if (!Object.values(db.objectStoreNames).find(object => object == 'likes')) {
                    db.createObjectStore("likes", { autoIncrement: false, keyPath:'id' });
                }
                if (!Object.values(db.objectStoreNames).find(object => object == 'buscas')) {
                    db.createObjectStore("buscas", { autoIncrement: true, keyPath:'id' });
                }
                if (!Object.values(db.objectStoreNames).find(object => object == 'images')) {
                    db.createObjectStore("images", { autoIncrement: false, keyPath:'imghash' });
                }
                if (!Object.values(db.objectStoreNames).find(object => object == 'cart')) {
                    db.createObjectStore("cart", { autoIncrement: false, keyPath:'sku' });
                }
                if (!Object.values(db.objectStoreNames).find(object => object == 'views')) {
                    db.createObjectStore("views", { autoIncrement: true, keyPath:'cod' });
                }
            };
            request.onerror = e => {
                console.log('Error opening db', e);
                reject('Error');
            };
            request.onsuccess = e => {
                DB = e.target.result;
                resolve(DB);
            };
        });
    },
    async resetDataTable(table) {
        let db = await this.getDb();
        return new Promise(resolve => {
            try {
                let trans = db.transaction([table],'readwrite');
                trans.oncomplete = () => {
                    resolve();
                };
                let store = trans.objectStore(table);
                store.clear();
            } catch (e) {
                console.log(e);
            }
        });
    },
    async deleteData(table, id) {
        let db = await this.getDb();
        return new Promise(resolve => {
            try {
                let trans = db.transaction([table],'readwrite');
                trans.oncomplete = () => {
                    resolve();
                };
                let store = trans.objectStore(table);
                store.delete(id);
            } catch (e) {
                console.log(e);
            }
        });
    },
    async getData(table) {
        let db = await this.getDb();
        return new Promise(resolve => {
            try {
                let trans = db.transaction([table],'readonly');
                trans.oncomplete = () => {
                    resolve(data);
                };
                let store = trans.objectStore(table);
                let data = [];
                store.openCursor().onsuccess = e => {
                    let cursor = e.target.result;
                    if (cursor) {
                        data.push(cursor.value)
                        cursor.continue();
                    }
                };
            } catch (e) {
                console.log(e);
            }
        });
    },
    async loadData(table, data, resetTable = false) {
        data = JSON.parse(JSON.stringify(data));
        let db = await this.getDb();
        if (resetTable) {
            await this.resetDataTable(table);
        }
        return new Promise(resolve => {
            try {
                let trans = db.transaction([table],'readwrite');
                trans.oncomplete = () => {
                    resolve(true);
                };
                let store = trans.objectStore(table);
                if (Array.isArray(data)) {
                    data.forEach(function (element) {
                        store.put(element);
                    });
                } else {
                    store.put(data);
                }
            } catch (e) {
                console.log(e);
            }
        });
    },
    async loadBlob(table, data, resetTable = false) {
        delete data.response.config;
        delete data.response.request;
        let db = await this.getDb();
        if (resetTable) {
            await this.resetDataTable(table);
        }
        return new Promise(resolve => {
            try {
                let trans = db.transaction([table],'readwrite');
                trans.oncomplete = () => {
                    resolve(true);
                };
                let store = trans.objectStore(table);
                store.put(data);
            } catch (e) {
                console.log(e);
            }
        });
    }
}